import StockCardActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperStockCard:[],
  errorInternal:false,
  printStockCard:null,
};

function StockCardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case StockCardActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case StockCardActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case StockCardActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case StockCardActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case StockCardActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case StockCardActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case StockCardActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case StockCardActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case StockCardActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case StockCardActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case StockCardActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case StockCardActions.GET_HELPER_CASHFLOW:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperStockCard:action.payload};
    case StockCardActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case StockCardActions.BEFORE_PRINT_CASHFLOW:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printStockCard:null,isProcessing:true};
    case StockCardActions.PRINT_CASHFLOW:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printStockCard:action.payload,isProcessing:false};
       
    default:
      return state;
    }
}

export default StockCardReducer;
